import React from "react";
import { styled } from "styled-components";
import { formatPriceNumber, formatWonToEokMan } from "../function";

interface Props {
  required: number; // 필요 능력치 (위 막대)
  actual: number; // 보유 능력치 (아래 막대)
  maxValue?: number;
  unit?: string; // 예: "ha/일"
  fractionDigits?: number; // 값 표시 소수점 자리수 (기본 2)
  isPrice?: boolean;
  className?: string;
}
const MIN_BAR_PX = 24;
const MAX_BAR_PX = 240;

function BarGraph({
  required,
  actual,
  maxValue = 1,
  unit = "",
  fractionDigits = 2,
  isPrice = false,
  className,
}: Props) {
  const safeRequired = required < 0 ? 0 : required;
  const safeActual = actual < 0 ? 0 : actual;

  // const requiredRatio = Math.min(safeRequired / maxValue, 1);
  // const actualRatio = Math.min(safeActual / maxValue, 1);
  const requiredRatio = safeRequired / maxValue;
  const actualRatio = safeActual / maxValue;

  // width 계산 (0이면 24px, 그 외에는 퍼센트)
  const requiredWidth =
    safeRequired === 0 ? `${MIN_BAR_PX}px` : `${requiredRatio * 100}%`;

  const actualWidth =
    safeActual === 0 ? `${MIN_BAR_PX}px` : `${actualRatio * 100}%`;

  // 점선 & 퍼센트 배지 위치는 "보유 능력치" 기준
  const indicatorPosPercent = safeActual === 0 ? 0 : actualRatio * 100;
  const indicatorPosition =
    indicatorPosPercent > 60 ? `${MAX_BAR_PX}px` : `${indicatorPosPercent}%`;

  // 퍼센트 계산 (required가 0이면 0%)
  const ratioPercent = safeActual === 0 ? 0 : (safeActual / safeRequired) * 100;
  const ratioLabel = `${Math.round(ratioPercent)}%`;

  const formatValue = (v: number) => {
    if (isPrice) {
      return formatWonToEokMan(v);
    } else {
      return v;
    }
  };

  return (
    <Wrapper className={className}>
      {/* {safeRequired > 0 && (
        <> */}
      <div style={{ maxWidth: "240px" }}>
        <GuideLine style={{ left: indicatorPosition }} />
        <RatioBadge style={{ left: indicatorPosition }}>
          {ratioLabel}
        </RatioBadge>
      </div>
      {/* </>
      )} */}

      <Row>
        <Bar style={{ width: requiredWidth }} $color="#8DE2C2" />
        <Label>
          {formatValue(safeRequired)}
          {unit}
        </Label>
      </Row>
      <Row>
        <Bar style={{ width: actualWidth }} $color="#1E9B6B" />
        <Label>
          {formatValue(safeActual)}
          {unit}
        </Label>
      </Row>
    </Wrapper>
  );
}

export default BarGraph;

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0 28px; /* 아래쪽 배지 공간 */
  height: 100px;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  z-index: 10;
`;

const Bar = styled.div<{ $color: string }>`
  height: 24px;
  border-radius: 100px;
  background-color: ${({ $color }) => $color};
  min-width: ${MIN_BAR_PX}px;
  max-width: ${MAX_BAR_PX}px;
  transition: width 0.2s ease;
`;

const Label = styled.div`
  background-color: #fff;
  color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Caption/L-12-Medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 116.667% */
`;

const GuideLine = styled.div`
  position: absolute;
  top: 0;
  width: 1px;
  height: 72px;
  border-left: 1px dashed #c6d0dd;
  pointer-events: none;
`;

const RatioBadge = styled.div`
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--Alias-Color-Text-White-BlueGray-700, #3d5066);
  color: var(--Alias-Color-Text-White-Gray-White, #fff);
  text-align: center;

  /* Web/Caption/L-14-Medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;
